import PageShell from "@/components/layout/PageShell";
import CostCentersSection from "@/components/CostCentersSection";

export default function MasterCostCentersPage() {
  return (
    <PageShell
      title="Cost Centres"
      subtitle="Billable departments for outward shipments · reusable master used across the app"
      overline="Master · Cost Centres"
    >
      <CostCentersSection />
    </PageShell>
  );
}
